const getPanelHeight = (panelWrap) => {
	if (!panelWrap) {
		return 0;
	}

	const panel = panelWrap.querySelector('.fc-knowledge-insights-dropdown__panel');
	return panel ? panel.scrollHeight : panelWrap.scrollHeight;
};

const closeItem = (item) => {
	const toggle = item.querySelector('[data-fc-kid-toggle]');
	const panelWrap = item.querySelector('[data-fc-kid-panel-wrap]');

	if (!toggle || !panelWrap || !item.classList.contains('is-open')) {
		return;
	}

	toggle.setAttribute('aria-expanded', 'false');
	panelWrap.style.maxHeight = `${getPanelHeight(panelWrap)}px`;

	window.requestAnimationFrame(() => {
		panelWrap.style.maxHeight = '0px';
		item.classList.remove('is-open');
	});
};

const openItem = (item) => {
	const toggle = item.querySelector('[data-fc-kid-toggle]');
	const panelWrap = item.querySelector('[data-fc-kid-panel-wrap]');

	if (!toggle || !panelWrap) {
		return;
	}

	panelWrap.hidden = false;
	panelWrap.style.maxHeight = '0px';
	toggle.setAttribute('aria-expanded', 'true');

	window.requestAnimationFrame(() => {
		panelWrap.style.maxHeight = `${getPanelHeight(panelWrap)}px`;
		item.classList.add('is-open');
	});
};

const closeAll = (block, except = null) => {
	block.querySelectorAll('.fc-knowledge-insights-dropdown__item.is-open').forEach((item) => {
		if (item !== except) {
			closeItem(item);
		}
	});
};

const updateOpenHeights = (block) => {
	block.querySelectorAll('.fc-knowledge-insights-dropdown__item.is-open').forEach((item) => {
		const panelWrap = item.querySelector('[data-fc-kid-panel-wrap]');
		if (panelWrap) {
			panelWrap.style.maxHeight = `${getPanelHeight(panelWrap)}px`;
		}
	});
};

const initKnowledgeInsightsDropdown = (block) => {
	if (!block || block.dataset.fcKidInit === '1') {
		return;
	}

	block.dataset.fcKidInit = '1';

	block.querySelectorAll('[data-fc-kid-panel-wrap]').forEach((panelWrap) => {
		panelWrap.style.maxHeight = '0px';
		panelWrap.addEventListener('transitionend', (event) => {
			if (event.propertyName !== 'max-height') {
				return;
			}

			const item = panelWrap.closest('.fc-knowledge-insights-dropdown__item');
			if (!item?.classList.contains('is-open')) {
				panelWrap.hidden = true;
			}
		});
	});

	block.querySelectorAll('[data-fc-kid-toggle]').forEach((toggle) => {
		toggle.addEventListener('click', () => {
			const item = toggle.closest('.fc-knowledge-insights-dropdown__item');
			if (!item) {
				return;
			}

			const isOpen = item.classList.contains('is-open');
			closeAll(block, item);

			if (isOpen) {
				closeItem(item);
				return;
			}

			openItem(item);
		});
	});

	block.querySelectorAll('[data-fc-kid-close]').forEach((close) => {
		close.addEventListener('click', () => {
			const item = close.closest('.fc-knowledge-insights-dropdown__item');
			if (!item) {
				return;
			}

			const toggle = item.querySelector('[data-fc-kid-toggle]');
			closeItem(item);
			toggle?.focus();
		});
	});

	document.addEventListener('click', (event) => {
		if (block.querySelector('.fc-knowledge-insights-dropdown__item.is-open') && !block.contains(event.target)) {
			closeAll(block);
		}
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && block.querySelector('.fc-knowledge-insights-dropdown__item.is-open')) {
			closeAll(block);
		}
	});

	window.addEventListener('resize', () => {
		updateOpenHeights(block);
	});
};

const initAll = () => {
	if (document.body?.classList.contains('wp-admin')) {
		return;
	}

	document
		.querySelectorAll('.wp-block-fc-block-fc-knowledge-insights-dropdown')
		.forEach(initKnowledgeInsightsDropdown);
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initAll);
} else {
	initAll();
}
